import React from 'react';

export const BackArrow = ({ onClick }) => (
  <svg width='24' height='24' fill='none' viewBox='0 0 24 24' className="back-arrow" onClick={onClick}>
    <path
      fill='#666'
      fillRule='evenodd'
      d='M14.447 17L9.67 12l4.777-5a1.202 1.202 0 000-1.656 1.093 1.093 0 00-1.592 0L7.33 11.121c-.232.241-.344.56-.329.879-.015.319.097.638.33.879l5.524 5.777a1.093 1.093 0 001.592 0 1.202 1.202 0 000-1.656z'
      clipRule='evenodd'
    ></path>
  </svg>
);
